var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimerDelay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.99484 14.6674C11.187 14.6674 13.7748 12.0796 13.7748 8.88742C13.7748 5.69522 11.187 3.10742 7.99484 3.10742C4.80264 3.10742 2.21484 5.69522 2.21484 8.88742C2.21484 12.0796 4.80264 14.6674 7.99484 14.6674Z",
    fill: "#D01400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99609 9.16732C7.72276 9.16732 7.49609 8.94065 7.49609 8.66732V5.33398C7.49609 5.06065 7.72276 4.83398 7.99609 4.83398C8.26943 4.83398 8.49609 5.06065 8.49609 5.33398V8.66732C8.49609 8.94065 8.26943 9.16732 7.99609 9.16732Z",
    fill: "#D01400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92318 2.30065H6.06984C5.80318 2.30065 5.58984 2.08732 5.58984 1.82065C5.58984 1.55398 5.80318 1.33398 6.06984 1.33398H9.92318C10.1898 1.33398 10.4032 1.54732 10.4032 1.81398C10.4032 2.08065 10.1898 2.30065 9.92318 2.30065Z",
    fill: "#D01400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerDelay);
export default __webpack_public_path__ + "static/media/timer_delay.a0a726a9beea9a977a2d0dcc11fdfe51.svg";
export { ForwardRef as ReactComponent };